module.exports = __webpack_public_path__ + "img/主页面.12872cdb.jpg";